import { usePrizesSeen } from "../api/hooks.ts";
import type { LeaderboardPrize } from "../api/types.ts";
import { copy } from "../copy/index.ts";
import styles from "./PrizeCard.module.css";
import { Button, Icon, Speak } from "./ui.tsx";

const t = copy.home.prize;

/**
 * Weekly leaderboard prize (D44): the coins are already in the child's purse; this card tells
 * the good news once, then the child taps it away.
 */
export function PrizeCard({ prizes }: { prizes: LeaderboardPrize[] }) {
  const seen = usePrizesSeen();
  if (!prizes.length || seen.isSuccess) return null;
  const lines = prizes.map((p) => t.line(p.rank, p.boardName, p.coins));
  return (
    <section className={styles.card} aria-labelledby="prize-title" aria-live="polite">
      <span className={styles.trophy}>
        <Icon name="trophy" size={56} />
      </span>
      <div className={styles.body}>
        <h2 id="prize-title">{t.title}</h2>
        {lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
      <div className={styles.actions}>
        <Speak text={[t.title, ...lines].join(" ")} />
        <Button disabled={seen.isPending} onClick={() => seen.mutate()}>
          {t.ok}
        </Button>
      </div>
    </section>
  );
}
